import { render, staticRenderFns } from "./NotificationEmail.vue?vue&type=template&id=4b17a486&scoped=true&"
import script from "./NotificationEmail.vue?vue&type=script&lang=js&"
export * from "./NotificationEmail.vue?vue&type=script&lang=js&"
import style0 from "./NotificationEmail.vue?vue&type=style&index=0&id=4b17a486&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b17a486",
  null
  
)

export default component.exports